import { isValueStringType } from '../../../utils/common'
import { stopPropagation } from '../../../utils/events'
import { useSelectContext } from '../Select.hooks'
import { SelectControlErrorText } from '../SelectControlErrorText'
import { SelectControlIndicators } from '../SelectControlIndicators'

function SelectControl({
  Container,
  Content,
  ErrorText = SelectControlErrorText,
  Indicators = SelectControlIndicators,
  contentProps,
  errorTextProps,
  indicatorsProps,
  openDropdownOnClickContainer = true,
  ref,
  onClickContainer,
  ...containerProps
}) {
  const { blocked, disabled, error, handleOpen, isOpen } = useSelectContext()

  function handleClickContainer(event) {
    stopPropagation(event)

    onClickContainer?.()

    if (openDropdownOnClickContainer && !disabled && !isOpen && !blocked) {
      handleOpen?.()
    }
  }

  return (
    <>
      <Container
        {...containerProps}
        focused={isOpen}
        ref={ref}
        onClick={handleClickContainer}
      >
        <Content {...contentProps} />
        <Indicators {...indicatorsProps} />
      </Container>
      {isValueStringType(error) && !!error && ErrorText ? (
        <ErrorText {...errorTextProps} text={error} />
      ) : null}
    </>
  )
}

export default SelectControl
